import { PageRouteBuilder } from "@common/route/page-route-builder";
import { SeedTrainingOrganisationsComponent } from "./seed-training-organisations.component";

export const seedTrainingOrganisationRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-seed-training-organisations", SeedTrainingOrganisationsComponent)
    .requiresLogin()
    .atUrl("/tools/seedTrainingOrganisations")
    .withTitle("Seed Training Organisations")
    .build();
